import React from "react";
import useSEO from "../hooks/useSEO";

export default function MentionsLegales() {
  useSEO({
    title: "Mentions légales",
    description:
      "Mentions légales de YONO SAS : éditeur, hébergeur, propriété intellectuelle, données personnelles.",
    path: "/mentions-legales",
  });

  return (
    <div data-testid="mentions-page">
      <section className="pt-20 pb-12">
        <div className="container-yono">
          <p className="eyebrow mb-6">Informations légales</p>
          <h1 className="font-heading text-[24px] sm:text-[34px] lg:text-[44px] tracking-tight leading-[1.04]">
            Mentions légales
          </h1>
        </div>
      </section>

      <div className="container-yono"><div className="h-line" /></div>

      <section className="section">
        <div className="container-yono grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-3" />
          <div className="lg:col-span-9 space-y-10 text-[14px] leading-[1.85] text-[var(--yono-soft-black)]/85">
            <div>
              <h2 className="font-heading text-2xl mb-4">Éditeur du site</h2>
              <p>Le présent site est édité par :</p>
              <div className="mt-3 space-y-1">
                <p>YONO SAS</p>
                <p>Société par actions simplifiée au capital social de 40 000 €</p>
                <p>Siège social : 119 rue d'Aboukir, 75002 Paris, France</p>
                <p>SIRET : 100 373 216 00017</p>
                <p>RCS : Paris</p>
                <p>TVA intracommunautaire : FR38100373216</p>
                <p>Site internet : www.yono-studio.com</p>
                <p>Email : contact@yono-habitat.com</p>
                <p>Téléphone : 06 83 58 18 04</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl mb-4">Directeur de la publication</h2>
              <p>Le directeur de la publication est Alexis Tessier, président de YONO SAS.</p>
            </div>

            <div>
              <h2 className="font-heading text-2xl mb-4">Hébergement</h2>
              <p>Le site est hébergé par :</p>
              <div className="mt-3 space-y-1">
                <p>OVH SAS</p>
                <p>2 rue Kellermann</p>
                <p>59100 Roubaix</p>
                <p>France</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl mb-4">Réalisation du site</h2>
              <p>Le site a été conçu et réalisé par YONO SAS.</p>
            </div>

            <div>
              <h2 className="font-heading text-2xl mb-4">Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus présents sur ce site, notamment les
                textes, images, photographies, rendus 3D, éléments graphiques,
                logos, marques, plans et documents, est la propriété exclusive
                de YONO SAS, sauf mention contraire.
              </p>
              <p className="mt-3">
                Toute reproduction, représentation, modification, diffusion ou
                exploitation, totale ou partielle, de ces éléments, sans
                autorisation écrite préalable de YONO SAS, est interdite.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl mb-4">Données personnelles</h2>
              <p>
                Les informations collectées via le formulaire de contact du
                site sont destinées à permettre à YONO SAS de répondre aux
                demandes reçues, d'étudier les projets présentés et, le cas
                échéant, d'envoyer des informations ou documents en lien avec
                ces demandes.
              </p>
              <p className="mt-3">
                Les données susceptibles d'être collectées sont notamment :
                nom, prénom, société, adresse email, numéro de téléphone et
                contenu du message.
              </p>
              <p className="mt-3">
                Ces données sont conservées pendant une durée maximale de 3 ans
                à compter du dernier échange.
              </p>
              <p className="mt-3">
                Conformément à la réglementation applicable, vous disposez d'un
                droit d'accès, de rectification, d'opposition, d'effacement et
                de limitation du traitement de vos données personnelles. Pour
                exercer ces droits, vous pouvez écrire à :
                contact@yono-habitat.com
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl mb-4">Cookies</h2>
              <p>
                Le site peut utiliser des cookies nécessaires à son bon
                fonctionnement ainsi que des outils de mesure d'audience ou de
                suivi statistique.
              </p>
              <p className="mt-3">
                Une bannière cookies permet à l'utilisateur d'accepter, de
                refuser ou de paramétrer les cookies non nécessaires au
                fonctionnement du site.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
